<template>
  <div>
    <app-cells position="between">
      <h1 class="title">Fuel log</h1>
      <app-button theme="warn" size="small" @click.native="onSyncData" ref="actual">Get updates</app-button>
    </app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view :key="key_for_rerender" />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { postCarManagementFuelLogsRefresh } from '@/http'

export default {
  name: 'FuelLogLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'car-management-fuel-log', label: 'Log', roles: [] },
        { name: 'car-management-fuel-log-invalid', label: 'Invalid values', roles: ['general_manager', 'transfer_supervisor', 'transfer_manager', 'accountant_supervisor'] },
        { name: 'car-management-fuel-log-vendors', label: 'Vendors', roles: [] },
      ],
      tabs_to_show: [],
      key_for_rerender: 1,
    }
  },
  created() {
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        this.tabs_to_show.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) this.tabs_to_show.push(item)
      })
    })
  },
  methods: {
    onSyncData() {
      this.$refs.actual.preload = true
      postCarManagementFuelLogsRefresh()
        .then(() => {
          this.$refs.actual.preload = false
          this.key_for_rerender += 1
        })
        .catch(() => { this.$refs.actual.preload = false })
    }
  }
}
</script>
